<template>
    <b-modal
        title-tag="h2"
        :title="title"
        :lazy="true"
        @hidden="close"
        :visible="isOpen"
    >
        <slot></slot>
        <template v-slot:modal-footer="{ cancel }">
            <loader v-if="isLoading" :margin="1" />

            <b-button
                class="mr-auto"
                variant="secondary"
                @click="cancel"
                v-if="!isLoading"
            >
                {{ cancelText }}
            </b-button>

            <b-button v-if="!isLoading" variant="primary" @click="proceed">
                {{ okText }}
            </b-button>
        </template>
    </b-modal>
</template>

<script>
import axios from "axios";
import Loader from "@/module/commons/loader";

export default {
    components: {
        Loader
    },
    props: {
        title: {
            type: String,
            default: "Delete"
        },
        okText: {
            type: String,
            default: "Yes"
        },
        cancelText: {
            type: String,
            default: "Cancel"
        },
        module: {
            type: String,
            required: true
        },
        patientId: {
            type: String
        }
    },
    data() {
        return {
            id: null,
            isLoading: false,
            isOpen: false,
            recordId: null
        };
    },
    methods: {
        open(recordId) {
            this.isOpen = true;
            this.recordId = recordId;
        },
        close() {
            this.isOpen = false;
        },
        async proceed() {
            try {
                this.isLoading = true;

                if (this.module === "communication") {
                    const res = await axios.get(
                        `${process.env.CI_APPS}patient/communication/remove`,
                        {
                            params: {
                                id: this.recordId
                            }
                        }
                    );

                    if (res.data.state === "0") {
                        this._message(res.data.message);
                    } else {
                        throw new Error(res.data.message);
                    }
                } else if (this.module === "diagnosis") {
                    const formData = new FormData();
                    formData.append("diagnosis_id", this.recordId);
                    formData.append("patient_id", this.patientId);
                    formData.append("referrer", "patient_snapshot");

                    const res = await axios.post(
                        `${process.env.CI_APPS}common/diagnosis/removeDiagnosis`,
                        formData
                    );

                    if (Number(res.data.state) === 0) {
                        this._message(res.data.message);
                    } else {
                        throw new Error(res.data.message);
                    }
                } else if (this.module === "currentPlan") {
                    const res = await axios.delete(
                        `${process.env.BARRAMUNDI}patient/current-plan/${this.recordId}`
                    );

                    if (
                        res.data.response &&
                        res.data.response.message &&
                        res.data.response.message.code === 200
                    ) {
                        this._message("Item removed.");
                    } else {
                        throw new Error("Unable to remove item.");
                    }
                }

                this.isLoading = false;
                this.close();
                this.$emit("onsuccess");
            } catch (e) {
                this._message(e.message, "danger");
                this.isLoading = false;
            }
        }
    }
};
</script>
